import { FC, useState, Fragment } from 'react';

import { Open16 } from 'ui/icons';
import { Popover, PopoverContent, PopoverPlacements } from 'ui/popover';
import { Body2, colors } from 'ui/theme';
import {
  Body2Bold,
  CenteredAnalyticsIcon,
  FlexLink,
  FlexWrapper,
  LightBody2EndAlign,
  MetricsKeyValuesContent,
  PopoverErrorWrapper,
  PopoverTriggerPaddedWrapper,
} from 'modules/frequencyManagement/components/engagementMetrics/EngagementMetricsPopover.styles';
import { Body2NoMargin } from 'modules/frequencyManagement/components/Content.styles';
import { EngagementMetricsSkeleton } from 'modules/frequencyManagement/components/engagementMetrics/EngagementMetricsSkeleton';

export const EngagementMetricsPopoverId = `engagement-metrics-popover`;

export interface EngagementMetricsPopoverProps {
  metricsDataPoints: string[];
  metricsDataValues: string[];
  insightsLink: string;
  onClickTrigger: () => void;
  isLoading: boolean;
  isError: boolean;
}
export const EngagementMetricsPopover: FC<EngagementMetricsPopoverProps> = ({
  insightsLink = '/messagingInsights',
  isError,
  isLoading,
  metricsDataPoints = [],
  metricsDataValues = [],
  onClickTrigger,
}) => {
  const [popoverIsOpen, togglePopoverIsOpen] = useState(false);
  let popoverContent = null;
  if (isLoading) {
    popoverContent = <EngagementMetricsSkeleton />;
  } else if (isError) {
    popoverContent = (
      <PopoverErrorWrapper>
        <Body2Bold>Hmm... we&apos;re having some trouble.</Body2Bold>
        <Body2>We couldn&apos;t load your prior month averages. Please try again.</Body2>
      </PopoverErrorWrapper>
    );
  } else {
    popoverContent = (
      <FlexWrapper>
        <Body2Bold>Averages (Prior month)</Body2Bold>
        <MetricsKeyValuesContent>
          {metricsDataPoints.map((dataPoint, index) => (
            <Fragment key={`${dataPoint}_${metricsDataValues[index]}`}>
              <Body2NoMargin>{metricsDataPoints[index]}</Body2NoMargin>
              <LightBody2EndAlign>{metricsDataValues[index]}</LightBody2EndAlign>
            </Fragment>
          ))}
        </MetricsKeyValuesContent>
        <FlexLink href={insightsLink} target="_blank" rel="noopener noreferrer">
          Open in Messaging Insights <Open16 color={colors.textLink} />
        </FlexLink>
      </FlexWrapper>
    );
  }
  return (
    <Popover onOpenChange={togglePopoverIsOpen}>
      <PopoverTriggerPaddedWrapper
        onClick={onClickTrigger}
        isOpen={popoverIsOpen}
        Icon={CenteredAnalyticsIcon}
      />
      <PopoverContent side={PopoverPlacements.Top}>{popoverContent}</PopoverContent>
    </Popover>
  );
};
